import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linkedTypeToUrl',
    standalone: true
})
export class LinkedTypeToUrlPipe implements PipeTransform {
    transform(value: string): unknown {
        const link = value === 'Event' ? 'RideEvent' : value;
        return link.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
}
